



























































































































































import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { resepStore } from "@/store/modules/resep";
import { storePasien } from "@/store/modules/pasien";
import { refResepStore } from "@/store/modules/ReferensiResep";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import ObatItemFastRow from "@/components/resep/ObatItemFastRow.vue";
import ResepRalanUnifiedSvc, { Regimen } from "@/services/ResepRalanUnified";
import { debounce } from "lodash";

@Component({
  components: { ObatSearchBox, ObatItemFastRow },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardResepRalanFastInput extends Vue {
  @Prop() resep_item: Array<any>;
  @Prop() items: Array<any>;
  @Prop() jenis: number;
  @Prop() showed: boolean;
  @Prop({ default: () => ({}) }) patientCtx: {
    bb?: number | string;
    alergi?: string;
    diagnosis?: string;
  };

  @Ref() readonly obatSearchBox!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  resepItems: any[] = [];
  addBtnLoading = false;
  showRegimenPicker = false;
  regimenSearch = "";
  regimenScope: "personal" | "all" = "personal";
  regimenList: Regimen[] = [];
  searchRegimen = debounce(() => this.loadRegimens(), 350);

  get depoId() {
    return resepStore.depoId;
  }

  get patientHeader() {
    const ident = storePasien.identitasPasien || ({} as any);
    return {
      nama: ident.nama || "—",
      nrm: ident.rm || ident.cm || "—",
      umur: ident.umur || "—",
      bb: this.patientCtx.bb,
      alergi: this.patientCtx.alergi || ident.alergi,
      diagnosis: this.patientCtx.diagnosis
    };
  }

  mounted() {
    this.setInputField();
    this.loadRegimens();
    this.ensureRefStoreLoaded();
  }

  ensureRefStoreLoaded() {
    if (!refResepStore.refRute || refResepStore.refRute.length === 0) {
      refResepStore.getRefRute();
    }
    if (!refResepStore.refFrekuensi || refResepStore.refFrekuensi.length === 0) {
      refResepStore.getRefFrekuensi();
    }
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    if (show) {
      this.setInputField();
      this.$nextTick(() => {
        this.$nextTick(() => this.focusToSearch());
      });
    }
  }

  setInputField() {
    this.resepItems = (this.items || []).map(it => ({ ...it }));
    this.resepItems.forEach(item => {
      item.frekuensi_id = item.frekuensi_id ?? item.frekuensi?.id ?? null;
      item.rute_id = item.rute_id ?? item.rute?.id ?? null;
      if (item.r) {
        item.sediaan_id = item.sediaan_id ?? item.sediaan?.id ?? null;
      }
    });
  }

  focusToSearch() {
    if (this.obatSearchBox && this.obatSearchBox.focus) {
      this.obatSearchBox.focus();
    }
  }

  addObatSingle(obat: any) {
    if (this.patientHeader.alergi) {
      const alergi = String(this.patientHeader.alergi).toLowerCase();
      const nm = String(obat.nama).toLowerCase();
      if (alergi.split(/[,;]+/).some(a => a.trim() && nm.includes(a.trim()))) {
        const ok = confirm(
          `PERHATIAN — pasien memiliki alergi "${this.patientHeader.alergi}" dan obat yang dipilih (${obat.nama}) mungkin terkait. Tetap tambahkan?`
        );
        if (!ok) return;
      }
    }

    this.resepItems.push({
      type: "nrc",
      obat_nama: obat.nama,
      qty: null,
      qty_unit: obat.satuan,
      harga: obat.harga,
      countedHarga: null,
      obat_id: obat.id,
      ap_rute: null,
      ap_frekuensi: null,
      ap_dosis: null,
      ap_tambahan: null,
      ap_template_id: null,
      ap_template_nama: null,
      r: "",
      frekuensi_id: null,
      rute_id: null
    });
  }

  removeItem(idx: number) {
    this.resepItems.splice(idx, 1);
  }

  validateItems(): boolean {
    const missing: string[] = [];
    this.resepItems.forEach(it => {
      if (!it.obat_id) missing.push("salah satu baris belum memilih obat");
      if (!it.qty || Number(it.qty) <= 0)
        missing.push(`${it.obat_nama || "Obat"}: jumlah wajib diisi`);
      if (!it.rute_id) missing.push(`${it.obat_nama}: rute wajib dipilih`);
      if (!it.frekuensi_id)
        missing.push(`${it.obat_nama}: frekuensi wajib dipilih`);
    });

    if (missing.length) {
      appModule.sendErrorAlert(
        "Belum lengkap:<br/>" + missing.slice(0, 5).join("<br/>")
      );
      return false;
    }
    return true;
  }

  submitItems() {
    if (this.readOnly) return;
    if (this.addBtnLoading) return;
    if (!this.validateItems()) return;

    this.addBtnLoading = true;
    setTimeout(() => {
      const cleaned = this.resepItems.map(it => {
        const copy: any = { ...it };
        delete copy._defaults_loaded;
        delete copy._auto_qty;
        delete copy._durasi_hari;
        return copy;
      });
      this.$emit("exportResepItem", cleaned);
      this.addBtnLoading = false;
      this.close();
    }, 200);
  }

  close() {
    this.resepItems = [];
    this.$emit("close");
  }

  openRegimenPicker() {
    this.showRegimenPicker = true;
    this.loadRegimens();
  }

  async loadRegimens() {
    try {
      this.regimenList = await ResepRalanUnifiedSvc.regimenFast({
        q: this.regimenSearch || "",
        scope: this.regimenScope
      });
    } catch (e) {
      this.regimenList = [];
    }
  }

  regimenSummary(r: Regimen): string {
    if (!r.items || r.items.length === 0) return r.text || "—";
    return r.items
      .slice(0, 3)
      .map(i => i.obat_nama)
      .join(", ") + (r.items.length > 3 ? `, +${r.items.length - 3} obat` : "");
  }

  applyRegimen(r: Regimen) {
    (r.items || []).forEach(item => {
      this.resepItems.push({
        type: "nrc",
        obat_nama: item.obat_nama,
        qty: item.qty,
        qty_unit: item.qty_unit,
        harga: null,
        countedHarga: null,
        obat_id: item.obat_id,
        ap_rute: null,
        ap_frekuensi: null,
        ap_dosis: item.ap_dosis,
        ap_tambahan: item.ap_tambahan,
        ap_template_id: null,
        ap_template_nama: null,
        r: item.r || "",
        frekuensi_id: item.frekuensi_id,
        rute_id: item.rute_id,
        _defaults_loaded: true
      });
    });
    this.showRegimenPicker = false;
    appModule.sendSuccessNotice(`Template "${r.nama}" diterapkan`);
    appModule.closeNoticeWithDelay();
  }
}
